module.exports = __webpack_public_path__ + "static/media/1011449.f2b1cf3f.png";